import React from 'react';
import { LanguageContextProvider } from '~/contexts/language';
import { SubjectCategoryContextProvider } from '~/contexts/subject-category';
import { UserContextProvider } from '~/contexts/user';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SharedDataContextProvider } from '../../contexts/shared-data';
import JITLoad from '~/helpers/jit-load';
import { SalesforceContextProvider } from '~/contexts/salesforce';
import { PortalContextProvider } from '~/contexts/portal';
import HeadlessUserbar from '~/components/headless-userbar/headless-userbar';
import ChromeFallback from './chrome-fallback';
import Error404 from '~/pages/404/404';
function AppContext({ children }) {
    return (React.createElement(SharedDataContextProvider, null,
        React.createElement(UserContextProvider, null,
            React.createElement(LanguageContextProvider, null,
                React.createElement(PortalContextProvider, null,
                    React.createElement(SubjectCategoryContextProvider, null, children))))));
}
const importContact = () => import('~/pages/contact/embedded.js');
function EmbeddedApp() {
    return (React.createElement(SalesforceContextProvider, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "contact", element: React.createElement(JITLoad, { importFn: importContact }) }),
            React.createElement(Route, { path: "*", element: React.createElement(Error404, null) }))));
}
const importRouter = () => import('./import-router.js');
function App() {
    return (React.createElement(AppContext, null,
        React.createElement(HeadlessUserbar, null),
        React.createElement(BrowserRouter, null,
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/embedded/*", element: React.createElement(EmbeddedApp, null) }),
                React.createElement(Route, { path: "*", element: React.createElement(JITLoad, { importFn: importRouter, fallback: React.createElement(ChromeFallback, null) }) })))));
}
export default React.createElement(App);
